// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/loss_rate_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { LossRateService } from "./loss_rate_service_pb";

/**
 * ListLossRateSettings returns loss-rate settings for all 10 areas in
 * a single response. The frontend filters by business-area settings
 * client-side to avoid per-area API calls on tab switch.
 *
 * @generated from rpc bffuser.v1.LossRateService.ListLossRateSettings
 */
export const listLossRateSettings = LossRateService.method.listLossRateSettings;
